import React, { Fragment, useEffect } from 'react'
import { Container, Card, Col, Row } from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import useAuth from '../../context/auth/useAuth'
import { useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { getRestaurants } from '../../actions/restaurantsActions'

export default function TakeRestaurant() {
	const { t } = useTranslation()
	const dispatch = useDispatch()
	const {client} = useAuth()

    const {restaurants} = useSelector(state=>state.restaurants)

	useEffect(() => {
		window.scrollTo({
            top:0,
            behavior: 'instant'
        })
		if(client){
			dispatch(getRestaurants())
		}
	},[dispatch, t, client])

	return (
		<Container className='p-5'>
			<Row className="mb-3">
				<Col xs={2} className='p-0'>
					<Link className="p-0 my-3" to="/client/dashboard">
                        <img src="../images/arrow-back.svg" alt="arrow-back" width={25}></img>
					</Link>
				</Col>
				<Col xs={8} className='text-center'>
					<h1 className='fs-18'>{t('client.takeorder.title')}</h1>
				</Col>
				<Col xs={2}></Col>
			</Row>
			<Row className="mt-5">
				<span className="sd-label-medium">{t('client.takeorder.restaurantsnow')}</span>
			</Row>
			<Row className="my-3">
				<Col>
					{restaurants?.map((restaurant, index) => (
						<Fragment key={index}>
							<Link className="p-0 my-3 text-decoration-none" to={`/client/takemenu/${restaurant._id}`}>
								<Card className="card-restaurants my-3">
									<div
									className="card-restaurant-image"
									style={restaurant.photo ? { backgroundImage: `url('${restaurant.photo}')` } : {}}
								>
									{!restaurant.photo &&
										<div className="card-restaurant-no-image">{restaurant.name.charAt(0).toUpperCase()}</div>
									}
								</div>
									<div className="cardbody-restaurants-client">
										<div className="d-flex justify-content-between align-items-center mb-1">
											<h2 className="fw-bold mb-0">{restaurant.name}</h2>
											<i className="fa-solid fa-right-long ms-2" style={{color: 'var(--naranja)'}}></i>
										</div>
										{restaurant.address &&
											<div className="text-muted small mb-2">
												<i className="fas fa-map-marker-alt me-1"></i>{restaurant.address}
											</div>
										}
										<div className="small" style={{color: 'var(--grisoscuro)'}}>
											{[
												{key: 'monday',    label: t('admin.restaurants.monday')},
												{key: 'tuesday',   label: t('admin.restaurants.tuesday')},
												{key: 'wednesday', label: t('admin.restaurants.wednesday')},
												{key: 'thursday',  label: t('admin.restaurants.thursday')},
												{key: 'friday',    label: t('admin.restaurants.friday')},
												{key: 'saturday',  label: t('admin.restaurants.saturday')},
												{key: 'sunday',    label: t('admin.restaurants.sunday')},
											]
											.filter(({key}) =>
												restaurant?.schedule?.[key]?.scheduleopen !== '00:00' ||
												restaurant?.schedule?.[key]?.scheduleclose !== '00:00'
											)
											.map(({key, label}) => (
												<span key={key} className="me-2">
													{`${label}: ${restaurant.schedule[key].scheduleopen} - ${restaurant.schedule[key].scheduleclose}`}
												</span>
											))}
										</div>
									</div>
								</Card>
							</Link>
						</Fragment>
					))}
				</Col>
			</Row>
		</Container>
	)
}